import { UilLinkH } from "@iconscout/react-unicons";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactComponent as CatalogoSVG } from "../../assets/newImages/home/catalog.svg";
import { ReactComponent as PedidoSVG } from "../../assets/newImages/home/pedido.svg";
import { ReactComponent as ProdutosSVG } from "../../assets/newImages/home/produtos.svg";
import { ReactComponent as RelatoriosSVG } from "../../assets/newImages/home/relatorios.svg";
import { ReactComponent as SacolaSVG } from "../../assets/newImages/home/sacola.svg";
import { ReactComponent as ClubeSVG } from "../../assets/newImages/home/IconeClubeConectado.svg";
import { ReactComponent as DashVisitasSVG } from "../../assets/newImages/icons/DashVisitas.svg";
import { ReactComponent as DashSacolasSVG } from "../../assets/newImages/icons/DashSacolas.svg";
import { ReactComponent as DashPedidosSVG } from "../../assets/newImages/icons/DashPedidos.svg";
import { ReactComponent as DashTicketSVG } from "../../assets/newImages/icons/DashTicket.svg";
import { ReactComponent as IconDown } from "../../assets/newImages/icons/downDash.svg";
import { ReactComponent as IconUp } from "../../assets/newImages/icons/upDash.svg";
import "./styles.ts";

import { ReactComponent as ZapZap } from "../../assets/newImages/icons/whatsapp.svg";
import { Button } from "../../components/Button/index.tsx";
import Modal from "../../components/Modal/Modal";
import PopoverInfo from "../../components/PopoverInfo/PopoverInfo";
import SkeletonHome from "../../components/Skeletons/SkeletonHome/SkeletonHome";
import SkeletonMetricasHome from "../../components/Skeletons/SkeletonMetricasHome/SkeletonMetricasHome";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { HeaderContext } from "../../contexts/Header/HeaderContext";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { configuracoesApi } from "../../hooks/configuracoesApi";
import { meetApi } from "../../hooks/meetApi.ts";
import { NotificacoesApi } from "../../hooks/notificacoesApi.ts";
import { metricasApi } from "../../hooks/metricasApi";
import { DadosDashboard } from "../../types/Metricas";
import { PERMISSOES } from "../../services/Consts";
import { staginEnv } from "../../services/Functions";
import "./styles";
import {
  ModalCafeConectadoContainer,
  ModalMentoriaContainer,
  ViewHome,
  ViewModal,
  CardsMetricas
} from "./styles.ts";

interface HomeProps {
  permissoesPlanos: string[];
}

const Home: React.FC<HomeProps> = ({ permissoesPlanos }) => {
  interface ModalData {
    ativo: boolean;
    texto?: string;
    link?: string;
    data?: string;
    tipo?: string;
    eventDate?: string;
    modal1data?: string;
    modal1texto?: string;
    modal2data?: string;
    modal2texto?: string;
  }

  const { theme } = useTheme();

  const { getMeets } = meetApi();

  const { permissoesUsuario, customizadas, loading: loadingPermissoes } =
    useContext(AuthContext);
  // Métricas não tem permissão grossa; customizado só vê com 160/161, não-customizado vê como hoje.
  const podeVerMetricas =
    !customizadas ||
    permissoesUsuario.includes(PERMISSOES.METRICAS_GERAL) ||
    permissoesUsuario.includes(PERMISSOES.METRICAS_MINHAS);
  const { empresa, setEmpresa } = useContext(EmpresaContext);
  const apiConf = configuracoesApi();
  const [temProdutos, setTemProdutos] = useState(false);
  const [modalMentoria, setModalMentoria] = useState(false);
  const [modalCafeConectado, setModalCafeConectado] = useState(false);
  const [mostrarMentoria, setMostrarMentoria] = useState(false);
  const [mentoriaGratis, setMentoriaGratis] = useState<{
    [key: string]: any;
  }>(/* initial value */);
  const [cafeConectado, setCafeConectado] = useState<{
    [key: string]: any;
  }>(/* initial value */);

  const [meets, setMeets] = useState([]);
  const [dadosDashboard, setDadosDashboard] = useState<DadosDashboard | null>(null);
  const [loadingMetricas, setLoadingMetricas] = useState(true);

  const { setModalTokensIa, modalTokensIa, temAulaNova, setTemAulaNova } =
    useContext(HeaderContext);

  const isAulaLida = async () => {
    try {
      const response = await NotificacoesApi().aulaLida();

      if (response == 1) {
        setTemAulaNova(false);
      }
    } catch (err) {
      console.error("err", err);
    }
  };

  const paginas = [
    {
      id_permissao: 13,
      id_menu: 4,
      name: "Meus pedidos",
      page_ref: "painel/pedidos",
      icon: PedidoSVG,
      tipo: "gerenciar",
    },
    {
      id_permissao: 21,
      id_menu: 8,
      name: "Sacolas abandonadas",
      page_ref: "painel/sacolas-abandonadas",
      icon: SacolaSVG,
      tipo: "gerenciar",
    },
    {
      id_permissao: 15,
      id_menu: 7,
      name: "Meus relatórios",
      page_ref: "painel/relatorios",
      icon: RelatoriosSVG,
      tipo: "gerenciar",
    },
    {
      id_permissao: 16,
      id_menu: 2,
      name: "Meus produtos",
      page_ref: "painel/produtos",
      icon: ProdutosSVG,
      tipo: "gerenciar",
    },
    {
      id_permissao: 14,
      id_menu: 3,
      name: "Meus catálogos",
      page_ref: "painel/catalogos",
      icon: CatalogoSVG,
      tipo: "gerenciar",
    },
  ];

  const [mostrarPopUp, setMostrarPopUp] = useState(false);
  const [showVideos, setShowVideos] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalWhatsapp, setModalWhatsapp] = useState(false);
  const [empresaNova, setEmpresaNova] = useState(false);
  const [modal1data, setModal1data] = useState<ModalData>({
    ativo: false,
    texto: "",
    link: "",
    data: "",
    eventDate: "",
    modal1data: "",
    modal1texto: "",
    modal2data: "",
    modal2texto: "",
  });

  const [modal2data, setModal2data] = useState<ModalData>({
    ativo: false,
    texto: "",
    link: "",
    data: "",
    eventDate: "",
    modal1data: "",
    modal1texto: "",
    modal2data: "",
    modal2texto: "",
  });

  useEffect(() => {
    const init = async () => {
      const temProdutos = await apiConf.verificar_step_criacao();
      if (temProdutos?.produtos) {
        setTemProdutos(true);
      } else {
        setTemProdutos(false);
      }

      try {
        const meets = await getMeets();

        // Verificar se mentoria_gratis existe e tem dados
        if (
          meets &&
          meets.mentoria_gratis &&
          Object.keys(meets.mentoria_gratis).length > 0
        ) {
          const todasAsDatas = Object.entries(meets.mentoria_gratis).flatMap(
            ([mes, datas]) => (datas as any[]).map((data) => ({ ...data, mes }))
          );

          const datasLimitadas = todasAsDatas.slice(0, 4);

          const mentoriaFiltrada = datasLimitadas.reduce((acc, item) => {
            if (!acc[item.mes]) acc[item.mes] = [];
            acc[item.mes].push({
              data: item.data,
              tipo: item.tipo,
              data_real: item.data_real,
              tema: item.tema,
              link: item.link,
              modal1data: item.modal1_data,
              modal2data: item.modal2_data,
              modal1texto: item.modal1_texto,
              modal2texto: item.modal2_texto,
            });
            return acc;
          }, {});

          setMentoriaGratis(mentoriaFiltrada);
        } else {
          console.log("Nenhum dado de mentoria_gratis disponível");
          setMentoriaGratis({});
        }

        // Verificar se cafe_conectado existe e tem dados
        if (
          meets &&
          meets.cafe_conectado &&
          Object.keys(meets.cafe_conectado).length > 0
        ) {
          const todasAsDatasCafe = Object.entries(meets.cafe_conectado).flatMap(
            ([mes, datas]) => (datas as any[]).map((data) => ({ ...data, mes }))
          );

          const datasLimitadasCafe = todasAsDatasCafe.slice(0, 4);

          const cafeFiltrado = datasLimitadasCafe.reduce((acc, item) => {
            if (!acc[item.mes]) acc[item.mes] = [];
            acc[item.mes].push({
              data: item.data,
              data_real: item.data_real,
              tipo: item.tipo,
              link: item.link,
              tema: item.tema,
              modal1data: item.modal1_data,
              modal2data: item.modal2_data,
              modal1texto: item.modal1_texto,
              modal2texto: item.modal2_texto,
            });
            return acc;
          }, {});

          setCafeConectado(cafeFiltrado);
        } else {
          console.log("Nenhum dado de cafe_conectado disponível");
          setCafeConectado({});
        }
      } catch (error) {
        console.error("Erro ao buscar dados de meets:", error);
        setMentoriaGratis({});
        setCafeConectado({});
      }
    };

    init();
  }, []);

  const isGerente = permissoesUsuario.includes(PERMISSOES.VISUALIZAR_PEDIDOS_GERENTE);

  // Carregamento separado das métricas
  useEffect(() => {
    const loadMetricas = async () => {
      setLoadingMetricas(true);
      try {
        const { getDadosDashboard } = metricasApi();
        const dataInicio = `${moment().subtract(7, "days").format("YYYY-MM-DD")} 00:00:00`;
        const dataFim = `${moment().format("YYYY-MM-DD")} 23:59:59`;

        const params: { data_inicio: string; data_fim: string; id_usuario?: string } = {
          data_inicio: dataInicio,
          data_fim: dataFim
        };

        if (!isGerente && empresa?.email_notificacao) {
          params.id_usuario = empresa.email_notificacao;
        }

        const dados = await getDadosDashboard(params);
        setDadosDashboard(dados);
      } catch (error) {
        console.error("Erro ao buscar dados do dashboard:", error);
      } finally {
        setLoadingMetricas(false);
      }
    };

    if (!loadingPermissoes && empresa && podeVerMetricas) {
      if (!isGerente && !empresa.email_notificacao) {
        return;
      }
      loadMetricas();
    }
  }, [isGerente, empresa, loadingPermissoes, podeVerMetricas]);

  useEffect(() => {
    const primeiraChave = cafeConectado
      ? Object.keys(cafeConectado)[0]
      : undefined;
    const primeiroRegistro = primeiraChave
      ? ((cafeConectado ?? {})[primeiraChave] ?? [])[0]
      : undefined;

    // Implementação da lógica para mostrar os modais
    if (primeiroRegistro) {
      // Função para verificar os modais
      const checkModals = () => {
        const now = moment();
        // Extrair modal1data e modal2data
        const modal1Time = moment(primeiroRegistro.modal1data);
        const modal2Time = moment(primeiroRegistro.modal2data);

        const eventTime = moment(primeiroRegistro.data_real);
        const eventDate = primeiroRegistro.data_real.split("T")[0]; // Get YYYY-MM-DD format

        // Verificar se já mostrou o modal1 hoje
        const modal1Key = `modal1_shown_${eventDate}`;
        const modal1AlreadyShown = localStorage.getItem(modal1Key) === "true";

        // Verificar se já mostrou o modal2 hoje
        const modal2Key = `modal2_shown_${eventDate}`;
        const modal2AlreadyShown = localStorage.getItem(modal2Key) === "true";

        // Verificar condições para Modal 1
        if (
          now.isAfter(modal1Time) &&
          now.isBefore(modal2Time) &&
          !modal1AlreadyShown
        ) {
          setModal1data({
            ativo: true,
            tipo: "cafe_conectado",
            texto: primeiroRegistro.modal1texto,
            link: primeiroRegistro.link,
            eventDate: primeiroRegistro.data,
          });
          setModal2data({ ativo: false });

          // Marcar como mostrado
          localStorage.setItem(modal1Key, "true");
        }
        // Verificar condições para Modal 2
        else if (
          now.isAfter(modal2Time) &&
          now.isBefore(eventTime) &&
          !modal2AlreadyShown
        ) {
          setModal2data({
            ativo: true,
            tipo: "cafe_conectado",
            texto: primeiroRegistro.modal2texto,
            link: primeiroRegistro.link,
            eventDate: primeiroRegistro.data,
          });
          setModal1data({ ativo: false });

          // Marcar como mostrado
          localStorage.setItem(modal2Key, "true");
        }

        // Fora das janelas de tempo, fechar ambos os modais
        else if (modal1data.ativo || modal2data.ativo) {
          setModal1data({ ativo: false });
          setModal2data({ ativo: false });
        }
      };

      // Verificar imediatamente
      checkModals();

      // Configurar verificação periódica
      const intervalId = setInterval(checkModals, 60000); // A cada minuto

      // Limpar o intervalo quando o componente for desmontado
      return () => clearInterval(intervalId);
    }
  }, [cafeConectado]);

  useEffect(() => {
    const primeiraChave = mentoriaGratis
      ? Object.keys(mentoriaGratis)[0]
      : undefined;
    const primeiroRegistro = primeiraChave
      ? ((mentoriaGratis ?? {})[primeiraChave] ?? [])[0]
      : undefined;

    if (primeiroRegistro) {
      const checkModals = () => {
        const now = moment();

        const modal1Time = moment(primeiroRegistro.modal1data);
        const modal2Time = moment(primeiroRegistro.modal2data);
        const eventTime = moment(primeiroRegistro.data_real);
        const eventDate = primeiroRegistro.data_real.split("T")[0];

        // Verificar se já mostrou os modais hoje
        const modal1Key = `mentoria_modal1_shown_${eventDate}`;
        const modal2Key = `mentoria_modal2_shown_${eventDate}`;
        const modal1AlreadyShown = localStorage.getItem(modal1Key) === "true";
        const modal2AlreadyShown = localStorage.getItem(modal2Key) === "true";

        if (
          now.isAfter(modal1Time) &&
          now.isBefore(modal2Time) &&
          empresaNova &&
          !modal1AlreadyShown
        ) {
          setModal1data({
            ativo: true,
            tipo: "mentoria_gratis",
            texto: primeiroRegistro.modal1texto,
            link: primeiroRegistro.link,
            eventDate: primeiroRegistro.data,
          });
          setModal2data({ ativo: false });

          // Marcar como mostrado
          localStorage.setItem(modal1Key, "true");
        }
        // Verificar condições para Modal 2
        else if (
          now.isAfter(modal2Time) &&
          now.isBefore(eventTime) &&
          empresaNova &&
          !modal2AlreadyShown
        ) {
          setModal2data({
            ativo: true,
            tipo: "mentoria_gratis",
            texto: primeiroRegistro.modal2texto,
            link: primeiroRegistro.link,
            eventDate: primeiroRegistro.data,
          });
          setModal1data({ ativo: false });

          // Marcar como mostrado
          localStorage.setItem(modal2Key, "true");
        }
        // Fora das janelas de tempo, fechar ambos os modais
        else if (modal1data.ativo || modal2data.ativo) {
          setModal1data({ ativo: false });
          setModal2data({ ativo: false });
        }
      };

      checkModals();

      const intervalId = setInterval(checkModals, 60000); // A cada minuto

      return () => clearInterval(intervalId);
    }
  }, [mentoriaGratis]);

  useEffect(() => {
    if (
      empresa?.data_ativacao &&
      window.localStorage.getItem("modalWhatsapp") !== "true"
    ) {
      const dataAtivacao = moment.utc(empresa.data_ativacao);
      const trintaDiasAtras = moment.utc().subtract(30, "days");

      if (dataAtivacao.isAfter(trintaDiasAtras)) {
        setModalWhatsapp(true);
      }
    }
  }, [empresa]);

  useEffect(() => {
    if (empresa?.data_ativacao) {
      const dataAtivacao = moment.utc(empresa.data_ativacao);
      const trintaDiasAtras = moment.utc().subtract(30, "days");

      if (dataAtivacao.isAfter(trintaDiasAtras)) {
        setMostrarMentoria(true);
        setEmpresaNova(true);
      }
    }
  }, [empresa]);

  return (
    <>
      <ViewHome theme={theme} paginas={paginas.length + 1} demo={empresa?.demo}>
        {loading || loadingPermissoes ? (
          <SkeletonHome />
        ) : (
          <>
            <div className="tituloHome fonteTitulo">Gerenciar e configurar</div>
            <div className="menus-container">
              <div className="menus">
                {paginas.map((pagina, index) => {
                  const temPermissao = permissoesUsuario.includes(pagina.id_permissao);
                  const menuContent = (
                    <div
                      className={`menu${!temPermissao ? " menu--disabled" : ""}`}
                      style={!temPermissao ? { opacity: 0.5, cursor: "not-allowed", position: "relative" } : {}}
                    >
                      <div className="image-container tamanhoIcone">
                        {React.createElement(pagina.icon)}
                      </div>
                      <div className="nomeMenu">
                        <div className="nome fonteSubtitulo">{pagina.name}</div>
                      </div>
                    </div>
                  );
                  return temPermissao ? (
                    <Link
                      to={pagina.page_ref}
                      key={pagina.id_menu}
                      style={{ textDecoration: "none" }}
                    >
                      {menuContent}
                    </Link>
                  ) : (
                    <div key={pagina.id_menu} title="Você não tem permissão para acessar">{menuContent}</div>
                  );
                })}
                <Link
                  to="/clube-conectado"
                  className="menuClubeConectado"
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (temAulaNova) {
                      isAulaLida();
                    }
                  }}
                >
                  <div className="image-container tamanhoIcone">
                    <ClubeSVG />
                  </div>
                  <div className="nomeMenuClubeConectado">
                    <div className="nomeClubeConectado fonteSubtitulo">
                      Clube conectado
                    </div>
                  </div>
                </Link>
              </div>
            </div>
            {podeVerMetricas && (
              <>
            <div className="tituloHome fonteTitulo">
              Métricas
              <span className="subtituloHome fonteRotulos">
                Dados atualizam duas vezes ao dia, não é em tempo real. Última atualização: {dadosDashboard?.atualizado_em ? moment(dadosDashboard.atualizado_em).format('DD/MM/YYYY [às] HH:mm[h]') : ''}
              </span>
            </div>
            {loadingMetricas ? (
              <SkeletonMetricasHome />
            ) : (
              <CardsMetricas theme={theme}>
                {/* Card Visitas */}
                <Link className="cardMetricas" to={'/metricas'}>
                  <div className="tituloCard">
                    <DashVisitasSVG className="iconeCard" />
                    <div className="nomeCard fonteRotulos">
                      <strong className="fonteTexto">Visitas</strong>
                      Últimos 7 dias
                    </div>
                  </div>
                  <div className="conteudoCard">
                    <div className="numerosCard">
                      <strong className="fonteSubtitulo">{dadosDashboard?.visitas?.total || 0}</strong>
                      <span className={`${(dadosDashboard?.visitas?.variacao || 0) >= 0 ? 'destaqueUpCard' : 'destaqueDownCard'} fonteRotulosCard`}>
                        {(dadosDashboard?.visitas?.variacao || 0) >= 0 ? <IconUp className="iconUpDown" /> : <IconDown className="iconUpDown" />}
                        {(dadosDashboard?.visitas?.variacao || 0) >= 0 ? '+' : ''}{(dadosDashboard?.visitas?.variacao || 0).toFixed(1)}%
                      </span>
                    </div>
                    <span className="rotuloCard fonteRotulosCard">
                      Comparado ao período anterior
                    </span>
                  </div>
                </Link>

                {/* Card Sacolas Abandonadas */}
                <Link className="cardMetricas" to={'/metricas'}>
                  <div className="tituloCard">
                    <DashSacolasSVG className="iconeCard" />
                    <div className="nomeCard fonteRotulos">
                      <strong className="fonteTexto">Sacolas abandonadas</strong>
                      Últimos 7 dias
                    </div>
                  </div>
                  <div className="conteudoCard">
                    <div className="numerosCard">
                      <strong className="fonteSubtitulo">{dadosDashboard?.sacolas_abandonadas?.total || 0}</strong>
                      <span className={`${(dadosDashboard?.sacolas_abandonadas?.variacao || 0) >= 0 ? 'destaqueUpCard' : 'destaqueDownCard'} fonteRotulosCard`}>
                        {(dadosDashboard?.sacolas_abandonadas?.variacao || 0) >= 0 ? <IconUp className="iconUpDown" /> : <IconDown className="iconUpDown" />}
                        {(dadosDashboard?.sacolas_abandonadas?.variacao || 0) >= 0 ? '+' : ''}{(dadosDashboard?.sacolas_abandonadas?.variacao || 0).toFixed(1)}%
                      </span>
                    </div>
                    <span className="rotuloCard fonteRotulosCard">
                      Comparado ao período anterior
                    </span>
                  </div>
                </Link>

                {/* Card Pedidos */}
                <Link className="cardMetricas" to={'/metricas'}>
                  <div className="tituloCard">
                    <DashPedidosSVG className="iconeCard" />
                    <div className="nomeCard fonteRotulos">
                      <strong className="fonteTexto">Pedidos</strong>
                      Últimos 7 dias
                    </div>
                  </div>
                  <div className="conteudoCard">
                    <div className="numerosCard">
                      <strong className="fonteSubtitulo">{dadosDashboard?.pedidos?.total || 0}</strong>
                      <span className={`${(dadosDashboard?.pedidos?.variacao || 0) >= 0 ? 'destaqueUpCard' : 'destaqueDownCard'} fonteRotulosCard`}>
                        {(dadosDashboard?.pedidos?.variacao || 0) >= 0 ? <IconUp className="iconUpDown" /> : <IconDown className="iconUpDown" />}
                        {(dadosDashboard?.pedidos?.variacao || 0) >= 0 ? '+' : ''}{(dadosDashboard?.pedidos?.variacao || 0).toFixed(1)}%
                      </span>
                    </div>
                    <span className="rotuloCard fonteRotulosCard">
                      Comparado ao período anterior
                    </span>
                  </div>
                </Link>

                {/* Card Ticket Médio */}
                <Link className="cardMetricas" to={'/metricas'}>
                  <div className="tituloCard">
                    <DashTicketSVG className="iconeCard" />
                    <div className="nomeCard fonteRotulos">
                      <strong className="fonteTexto">Ticket médio</strong>
                      Últimos 7 dias
                    </div>
                  </div>
                  <div className="conteudoCard">
                    <div className="numerosCard">
                      <strong className="fonteSubtitulo">
                        R$ {(dadosDashboard?.ticket_medio?.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </strong>
                      <span className={`${(dadosDashboard?.ticket_medio?.variacao || 0) >= 0 ? 'destaqueUpCard' : 'destaqueDownCard'} fonteRotulosCard`}>
                        {(dadosDashboard?.ticket_medio?.variacao || 0) >= 0 ? <IconUp className="iconUpDown" /> : <IconDown className="iconUpDown" />}
                        {(dadosDashboard?.ticket_medio?.variacao || 0) >= 0 ? '+' : ''}{(dadosDashboard?.ticket_medio?.variacao || 0).toFixed(1)}%
                      </span>
                    </div>
                    <span className="rotuloCard fonteRotulosCard">
                      Comparado ao período anterior
                    </span>
                  </div>
                </Link>
              </CardsMetricas>
            )}
              </>
            )}
            {empresa?.catalogo_principal &&
              temProdutos &&
              permissoesUsuario.includes(PERMISSOES.CONFIGURACOES) && (
                <div
                  onClick={() => {
                    navigator.clipboard
                      .writeText(
                        `${empresa?.dominio_https}${empresa?.catalogo_principal}${staginEnv()}`
                      )
                      .then(
                        (res) => {
                          Swal.fire({
                            title: "Link copiado com sucesso!",
                            text: "Agora você pode compartilhar o link do seu catálogo principal com seus clientes.",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        },
                        (err) => {
                          console.log("Erro ao copiar link", err);
                          Swal.fire({
                            title: "Erro ao copiar link!",
                            text:
                              "Mas você ainda pode copiar o link do seu catálogo principal manualmente. O link é: " +
                              `${empresa.dominio_https}${empresa.catalogo_principal}`,
                            icon: "error",
                            confirmButtonText: "Ok",
                          });
                        }
                      );
                  }}
                  className={`botaoCompartilhar hideDesktop fonteSubtitulo`}
                >
                  {permissoesUsuario.includes(PERMISSOES.USUARIOS_GERENTE) && (
                    <>
                      {" "}
                      <UilLinkH className="icone"></UilLinkH> Compartilhar
                      catálogo principal da conta
                    </>
                  )}
                </div>
              )}
            <div className="tituloHome fonteTitulo">Destaques</div>
            <div className="destaques">
              {mostrarMentoria ? (
                <div className="destaque">
                  {" "}
                  {/*Se a empresa tem menos de 30 dias mostra a mentoria gratuita */}
                  <div className="titulo-destaque fonteSubtitulo">
                    <span className="laranja">Mentoria Grátis</span> <br />
                    de Implementação
                  </div>
                  <div className="explicacao fonteTexto">
                    Um treinamento completo, toda a semana, com nossos especialistas
                  </div>
                  <div
                    className="btn-saber-mais fonteTexto"
                    onClick={() => {
                      if (empresa?.demo !== "true") {
                        setModalMentoria(!modalMentoria);
                      }
                    }}
                  >
                    Saber mais
                  </div>
                </div>
              ) : (
                <Link
                  className="destaque fonteTexto"
                  to="https://chat.whatsapp.com/H72svp2vpw27Hc2GpiD40M"
                  target="_blank"
                >
                  {" "}
                  {/*Se a empresa tem mais de 30 dias mostra o grupo do whatsapp */}
                  <div className="titulo-destaque fonteSubtitulo">
                    <span className="laranja">Grupo de conteúdos</span> <br />
                    no WhatsApp
                  </div>
                  <div className="explicacao">
                    Seu negócio evoluiu,  receba conteúdos para vender mais.
                  </div>
                  <div className="btn-saber-mais">
                    <ZapZap /> Entrar no grupo
                  </div>
                </Link>
              )}
              <Link className="destaque fonteTexto" to="/destaques">
                <div className="titulo-destaque fonteSubtitulo">
                  <span className="laranja">Benefícios</span> <br />
                  exclusivos
                </div>
                <div className="explicacao">
                  Confira vantagens dos nossos parceiros para você.
                </div>
                <div className="btn-saber-mais">Conferir</div>
              </Link>
              <Link className="destaque fonteTexto" to="/destaques">
                <div className="titulo-destaque fonteSubtitulo">
                  <span className="laranja">Atualizações</span> <br />
                  do sistema
                </div>
                <div className="explicacao">
                  Atualizações e novidades em primeira mão você encontra aqui.
                </div>
                <div className="btn-saber-mais">Conferir</div>
              </Link>
              <Modal
                isOpen={modalMentoria}
                setModal={setModalMentoria}
                width={"auto"}
                align={"center"}
                justify="center"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
                borderRadius="30px"
              >
                <ModalMentoriaContainer theme={theme}>
                  <div className="cabecalho-modal">
                    <div className="titulo fonteTitulo">
                      Mentoria Grátis de Implementação
                    </div>
                    <div className="subtitulo-criacao fonteTexto">
                      Um treinamento completo, toda a semana, com nossos especialistas
                    </div>
                  </div>
                  {Object.entries(mentoriaGratis || {}).map(
                    ([mes, datas], index_mes) => (
                      <div key={mes} className="mes">
                        <div className="nome fonteSubtitulo">{mes}</div>
                        <div className="datas">
                          {datas.map((item, index) => (
                            <div key={index} className="data">
                              <div className="data-tema">
                                <div className="dia fonteTexto">{item.data}</div>
                                {item.tema && (
                                  <div className="tema fonteRotulos"><strong>Tema:&nbsp;</strong><span>{item.tema}</span></div>
                                )}
                              </div>
                              <a
                                href={`https://meet.google.com/${item.link}`}
                                target="_blank"
                                className={
                                  item.link && index == 0 && index_mes == 0
                                    ? "btn-live-ativo fonteTexto"
                                    : "btn-live fonteTexto"
                                }
                              >
                                {item.link ? "Entrar ao vivo" : "Encerrado"}
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  )}
                </ModalMentoriaContainer>
              </Modal>
              {/* <Modal
                isOpen={modalCafeConectado}
                setModal={setModalCafeConectado}
                width={"auto"}
                align={"center"}
                justify="center"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
                borderRadius="30px"
              >
                <ModalCafeConectadoContainer theme={theme}>
                  <div className="cabecalho-modal">
                    <div className="titulo fonteTitulo">Café Conectado</div>
                    <div className="subtitulo-criacao fonteTexto">
                      Um encontro mensal, ao vivo, com conteúdo relevante de mercado.
                    </div>
                  </div>

                  {Object.entries(cafeConectado || {}).map(
                    ([mes, datas], index_mes) => (
                      <div key={mes} className="mes">
                        <div className="nome fonteSubtitulo">{mes}</div>
                        <div className="datas">
                          {datas.map((item, index) => (
                            <div key={index} className="data">
                              <div className="temaData">
                                <div className="dia fonteTexto">{item.data}</div>
                                {item.tema && (
                                  <div className="tema-texto fonteTexto">
                                    <strong className="fonteTexto">Tema:</strong> {item.tema}
                                  </div>
                                )}
                              </div>
                              <a
                                href={`https://meet.google.com/${item.link}`}
                                target="_blank"
                                className={
                                  item.link && index == 0 && index_mes == 0
                                    ? "btn-live-ativo"
                                    : "btn-live"
                                }
                              >
                                {item.link ? "Participar" : "Encerrado"}
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  )}
                </ModalCafeConectadoContainer>
              </Modal> */}
            </div>
            {empresa?.catalogo_principal &&
              temProdutos &&
              permissoesUsuario.includes(PERMISSOES.CONFIGURACOES) && (
                <div
                  onClick={() => {
                    navigator.clipboard
                      .writeText(
                        `${empresa?.dominio_https}${empresa?.catalogo_principal}${staginEnv()}`
                      )
                      .then(
                        (res) => {
                          Swal.fire({
                            title: "Link copiado com sucesso!",
                            text: "Agora você pode compartilhar o link do seu catálogo principal com seus clientes.",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        },
                        (err) => {
                          console.log("Erro ao copiar link", err);
                          Swal.fire({
                            title: "Erro ao copiar link!",
                            text:
                              "Mas você ainda pode copiar o link do seu catálogo principal manualmente. O link é: " +
                              `${empresa.dominio_https}${empresa.catalogo_principal}`,
                            icon: "error",
                            confirmButtonText: "Ok",
                          });
                        }
                      );
                  }}
                  className={`botaoCompartilhar hideMobile fonteSubtitulo`}
                >
                  {permissoesUsuario.includes(PERMISSOES.USUARIOS_GERENTE) && (
                    <>
                      {" "}
                      <UilLinkH className="icone"></UilLinkH> Compartilhar
                      catálogo principal da conta
                    </>
                  )}
                </div>
              )}
          </>
        )}
      </ViewHome>

      {/*   Modal 1  */}

      <Modal
        isOpen={modal1data.ativo}
        setModal={() => setModal1data({ ativo: false })}
        width={"105rem"}
        maxWidth="98vw"
      >
        <>
          <ViewModal theme={theme}>
            <div className="ParabensContainer">
              <img
                src={require(
                  `../../assets/newImages/home/novidades/banner-${modal1data.tipo == "mentoria_gratis" ? "mentoria" : "cafe"
                  }.png`
                )}
                alt=""
                className="BannerModal"
              />
              <div
                className="texto"
                dangerouslySetInnerHTML={{ __html: modal1data.texto || "" }}
              ></div>
            </div>
          </ViewModal>
        </>
      </Modal>

      {/*   Modal 2  */}

      <Modal
        isOpen={modal2data.ativo}
        setModal={() => setModal2data({ ativo: false })}
        width={"100rem"}
        maxWidth="98vw"
      >
        <>
          <ViewModal theme={theme}>
            <div className="ParabensContainer">
              <img
                src={require(
                  `../../assets/newImages/home/novidades/banner-${modal2data.tipo == "mentoria_gratis" ? "mentoria" : "cafe"
                  }.png`
                )}
                alt=""
                className="BannerModal"
              />
              <div
                className="texto"
                dangerouslySetInnerHTML={{ __html: modal2data.texto || "" }}
              ></div>
              <div className="botao">
                <Button
                  title="Participar da live"
                  onClick={() => {
                    window.localStorage.setItem("modalWhatsapp", "true");
                    window.open(
                      "https://meet.google.com/" + modal2data.link,
                      "_blank"
                    );
                    setModal2data({ ativo: false });
                  }}
                />
              </div>
            </div>
          </ViewModal>
        </>
      </Modal>
    </>
  );
};

export default Home;
